<template>
  <v-menu min-width="300" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        elevation="0"
        class="ml-4"
        v-on="on"
      >
        Фильтр по ролям
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click.stop.prevent="">
        <v-autocomplete
          v-model="selectedItemsList"
          class="my-2"
          label="Роли"
          item-value="id"
          item-text="name"
          multiple
          hide-details
          :items="itemsList"
          :disabled="isLoading"
          @change="$emit('change', selectedItemsList)"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" class="caption">
              {{ getDeclination(selectedItemsList.length, ['Выбрана', 'Выбрано', 'Выбраны']) }}
              {{ selectedItemsList.length }}
              {{ getDeclination(selectedItemsList.length, ['роль', 'роли', 'ролей']) }}
            </span>
          </template>
        </v-autocomplete>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import getDeclination from '@/utils/declinationOfNumber';

export default {
  name: 'users-filter',

  props: {
    itemsList: {
      type: Array,
      default: () => ([]),
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    isLoading: Boolean,
  },

  data: () => ({
    selectedItemsList: [],
  }),

  created() {
    this.selectedItemsList = [...this.selectedItems];
    this.getDeclination = getDeclination;
  },
};
</script>
